import intl from "react-intl-universal";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { ClbButton, ClbIcon, ClbText } from "@celebration/design-system-react";
import { getSupplierStockDaysRemaining } from "utils/supplier-stock-transition";
import * as S from "./supplier-stock-transition-banner.styled";

export const SupplierStockTransitionBanner = ({ decommissionAt, history }) => {
  const daysRemaining = getSupplierStockDaysRemaining(decommissionAt);

  return (
    <S.SupplierStockTransitionBanner data-testid="supplier-stock-transition-banner">
      <ClbIcon icon="Warning" type="warning" size="md" />
      <S.BannerContent>
        <S.BannerStatus>
          <ClbText size="md" style={{ "--font-weight-regular": "var(--font-weight-semibold)" }}>
            {intl.get("supplierStock.transition.title", { count: daysRemaining })}
          </ClbText>
          <ClbText size="sm">{intl.get("supplierStock.transition.message")}</ClbText>
        </S.BannerStatus>
      </S.BannerContent>
      <ClbButton
        data-testid="supplier-stock-transition-cta"
        icon="ArrowRight"
        iconPosition="left"
        onClbClick={() => history.push("/production-plan-supplier")}
        size="sm"
        styleType="tertiary"
      >
        {intl.get("supplierStock.transition.cta")}
      </ClbButton>
    </S.SupplierStockTransitionBanner>
  );
};

SupplierStockTransitionBanner.propTypes = {
  decommissionAt: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(SupplierStockTransitionBanner);
